import { useSelector } from '@tabeeb/store'
import { List, TextField } from '@mui/material'
import { useMemo } from 'react'
import ParticipantItem from '@tabeeb/modules/invites/components/ParticipantsList/ParticipantItem'
import { useDebouncedState } from '@tabeeb/shared/utils/hooks'
import { getUsersListForCurrentUser } from '../../../../users/selectors'
import { PluginUser } from '../../../../users/types'

const ParticipantsList = () => {
  const users = useSelector(getUsersListForCurrentUser)
  const [search, debouncedSearch, setSearch] = useDebouncedState<string>('', 150)

  const filteredUsers = useMemo(() => {
    const searchText = (debouncedSearch ?? '').toLocaleLowerCase().trim()

    let result: PluginUser[]

    if (!searchText) {
      result = users.filter((u) => !u.isDeleted)
    } else {
      result = users.filter((user) => {
        if (user.isDeleted) {
          return false
        }

        const name = (user.displayName ?? '').toLocaleLowerCase()
        const email = (user.email ?? '').toLocaleLowerCase()
        const phone = (user.phoneNumber ?? '').toLocaleLowerCase()

        return name.includes(searchText) || email.includes(searchText) || phone.includes(searchText)
      })
    }

    return result.sort((a, b) => {
      if (a.isOwner === b.isOwner) {
        return 0
      }
      return a.isOwner ? -1 : 1
    })
  }, [users, debouncedSearch])

  return (
    <>
      <TextField
        label='Search users'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        variant='outlined'
        sx={{ mb: 1 }}
        size='small'
      />
      <List disablePadding dense sx={{ overflowY: 'auto', flex: 1 }}>
        {filteredUsers.map((user) => (
          <ParticipantItem key={user.id} user={user} />
        ))}
      </List>
    </>
  )
}

export default ParticipantsList
